import { faHandPointRight } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useEffect, useState } from 'react';
import { Slide } from 'react-reveal';
import BookStoreAnimate from '../../PowerFullAnimation/BookStoreAnimate';
import BookStoreCart from './BookStoreCart';
import PopularCourseCartAimation from '../../PowerFullAnimation/PopularCourseCartAimation';

const BookStore = () => {
    const [book, setBook] = useState([]);
    const [loadding, setLoadding] = useState(true);
    const [show, setShow] = useState(false);


    useEffect(() => {
        fetch('BookStore.json')
            .then(res => res.json())
            .then(data => {
                setBook(data);
                setLoadding(false);
            })
            .catch(err => {
                setLoadding(true)
            })
    }, [book])

    return (
        <div className=''>
            <div className="book-title mb-3">
                <Slide right>
                    <h4 className='fw-bold'>স্কিল ডেভেলপমেন্ট বইসমূহ</h4>
                </Slide>
            </div>
            <div className="courbook">
                <div className="row gy-5">
                    {
                        show ? book?.map(books => <BookStoreCart books={books} key={books?._id} />) : book?.slice(0, 8)?.map(books => <BookStoreCart books={books} key={books?._id} />)

                    }

                </div>

            </div>
            <div className="setLoadding">
                {
                    loadding ? <>
                        <PopularCourseCartAimation />
                        <div className="mt-5 mb-5"></div>
                        <PopularCourseCartAimation />
                    </>
                        : ''
                }
            </div>
            <div className="skkitBtn mt-5 text-center">
                <button className='btn btn-danger fs-5' onClick={() => setShow(!show)}> স্কিল ডেভেলপমেন্ট সকল বই দেখো  <FontAwesomeIcon icon={faHandPointRight} className='ms-1' /></button>
            </div>
        </div>
    );
};

export default BookStore;